import { Component, OnInit } from '@angular/core';
import { OtlobxReportService } from '../../services/otlobx-report.service';
import { Report } from '../../report';
import * as moment from 'moment';
import { CurrentSessionService } from 'src/app/shared/services/current-session.service';

@Component({
  selector: 'app-otlobx-report',
  templateUrl: './otlobx-report.component.html',
  styleUrls: ['./otlobx-report.component.scss'],
})
export class OtlobxReportComponent implements OnInit {
  tableColumns: string[] = [
    'id',
    'username',
    'userPhone',
    'title',
    'description',
    'status',
    'isPublic',
    'price',
    'extraText',
    'photos',
    'bids',
    'views',
    'shares',
    'favourites',
    'city',
    'governorate',
    'created_at',
  ];
  displayTableColumns = {
    id:'id',
    title: 'title',
    description: 'description',
    status: 'status',
    isPublic: 'is Public',
    price: 'price',
    created_at: 'created_at',
    photos: 'photos',
    bids: 'bids',
    views:'views',
    shares: 'shares',
    favourites:'favourites',
    extraText:'extra Text',
    username: 'username',
    userPhone: 'userPhone',
    city: 'city',
    governorate: 'governorate',
  };

  totalNumberOfRecords: number = 0;
  otlobxReportData: any[] = [];
  loading = false;
  requestBody: Report = {};
  isAssignedBusinessSelected: boolean = false

  constructor(
    public otlobxReportService: OtlobxReportService,
    private getCurrentSessionService: CurrentSessionService,
  ) {}

  ngOnInit(): void {
    this.otlobxReportService.activateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  async filter(event: any) {
    if (event && Object.keys(event).length) {
      console.log("filter should not be null");
      this.requestBody.filterOptions = event;
    } else {
      console.log("filter should be null");
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.otlobxReportService.loader().subscribe(val => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.otlobxReportService.loader().subscribe(val => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.otlobxReportService.loader().subscribe(val => (this.loading = val));
    }
    this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    this.updateTable();
    this.otlobxReportService.loader().subscribe(val => (this.loading = val));
  }

  async updateTable() {
    this.otlobxReportService.activateLoader();
    if (this.requestBody['filterOptions'] && this.requestBody['filterOptions']['createdAt']) {
      // @ts-ignore
      const { startDate, endDate } = this.requestBody['filterOptions']['createdAt'];
      this.requestBody.filterOptions.createdAt.from = moment(startDate).format('YYYY-MM-DD') + " 00:00:00";
      this.requestBody.filterOptions.createdAt.to = moment(endDate).format('YYYY-MM-DD') + " 23:59:59";
    }
    if (this.isAssignedBusinessSelected){
      if(!this.requestBody['filterOptions']){
        this.requestBody['filterOptions'] = {}
      }
      const adminId =(await this.getCurrentSessionService.make())?.data?.userId;
      this.requestBody['filterOptions']['adminId'] = adminId
    } else {
      delete this.requestBody?.filterOptions?.adminId
    }
    this.otlobxReportService.setParams(this.requestBody);
    const report = await this.otlobxReportService.make();
    this.otlobxReportData = report.data.result
    this.totalNumberOfRecords = report.data.totalNumberOfRows;
  }

  assignedBusinessesFilterChanged(value){
    this.isAssignedBusinessSelected = value;
  }
}
